import controller from './more.controller.js';
import template from './more.html';
import './more.scss';

let module = angular.module('more', [
	'ionic'
])
.config(($stateProvider) => {
	"ngInject";

	$stateProvider
		.state('tab.more', {
			url: '/more',
			views: {
				'tab-more': {
					template: template,
					controller: controller,
					controllerAs: 'more'
				}
			}
		})
})
.name;

export default module;



// WEBPACK FOOTER //
// ./app/components/more/more.js